export const formatNumber = (n: number): string => n.toLocaleString('en-AU');

export const formatCurrency = (n: number): string =>
  `$${n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
